import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAppStoreVersion } from "@app/redux/actions/appstore_version";
import api from "@app/redux/api/base-api";

/**
 * Custom hook to fetch latest appstore version from the API and store them in Redux.
 * It fetches latest appstore version from API when the component is mounted, and dispatches it to the Redux store.
 * @returns {void} - This hook does not return any value.
 */

const useGetAppstoreVersion = (isLoggedIn: boolean = false): void => {
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchVersion = async () => {
            try {
                const response = await api.get("/appstore-version/");
                if (response) {
                    console.log(response.data);
                    dispatch(fetchAppStoreVersion(response.data.data?.appstore_version));
                }
            } catch (error) {
                console.log("Error fetching feature settings", error);
            }
        };
        if (isLoggedIn) {
            fetchVersion();
        }
    }, [dispatch, isLoggedIn]);
};

export default useGetAppstoreVersion;
